import { productsAndServicesApi } from 'api';

export const distributeCaseDocuments = async (caseId: string, documentIds: string[]) => {
  return await productsAndServicesApi.distributeCaseDocuments({
    caseId: Number(caseId),
    documentDeliveryRequest: { documentIds: documentIds.map(Number) },
  });
};
